import React from 'react';
import { Text, List, ListItem, Icon, Button, CardHeader, Card, Layout} from '@ui-kitten/components';
import { Q_GET_CAMPAIGN, Q_GET_CAMPAIGN_AND_SURVEYS } from '../../data/api/query/q_campaigns';
import { useQuery } from '@apollo/react-hooks';
import { StyleSheet, View, Platform, FlatList } from 'react-native';
import { SideHeaderList } from '../../components/containers/SideHeaderListProps';
import { ItemTypeHeader, SurveyCard } from '../../components/list-items/CardItem';
import { AuthContext } from '../../App';
import { PageLoadingIndicator } from '../../components/LoadingIndicator';
import { useScreenDimensions, getItemWidth } from '../../utils/useScreenInfo';





export default function CampaignScreen({ navigation, route }): React.ReactElement {
    const { isMediumScreenOrLarger, isLargeScreenOrLarger } = useScreenDimensions();
    const { pageSpacerHorizontal } = getItemWidth({ isMediumScreenOrLarger, isLargeScreenOrLarger });
    const params = route?.params;
    console.log({ navigation, route, params });
    const isPoallCampaign: boolean = params?.campaign === 'f02d28cb-40c8-40da-bb2c-1980e4fd81fb';
    const { user } = React.useContext(AuthContext);
    const queryParams: any = {
        campaign_id: params.campaign,
        author_id: isPoallCampaign ? undefined : user.id
    };
    const { loading, error, data, refetch } = useQuery(Q_GET_CAMPAIGN_AND_SURVEYS, {
        variables: queryParams,
        fetchPolicy: 'network-only'
    });


    if (loading) return <PageLoadingIndicator />;
    if (error) return <Text>Error :(</Text>;
    console.log('we have data, ', data)
    const { id, title, description, surveys, created_at, updated_at } = data.campaigns[0];
    const _onPress = (survey_id: string) => {
        if (isPoallCampaign) {
            navigation.navigate('Surveys', { screen: 'Survey', params: { survey: survey_id } })
        }
        else {
            navigation.navigate('Surveys', { screen: 'Survey', params: { survey: survey_id } })
        }
    }


    const renderSurvey = ({ item }) => (
        <SurveyCard
            item={item}
            onPress={() => _onPress(item.id)}
            key={item.id}
        />
    );

    const renderHeader = (): React.ReactElement => (
        <Card style={{ marginTop: pageSpacerHorizontal }}>
            <ItemTypeHeader title='CAMPAIGN' icon='award-outline'  />
            <Text category='h2'>{title}</Text>
            <Text category='s1'>{description}</Text>
            {/* <Text category='p1'>Survey Count: {surveys.length}</Text> */}
            <Text category='p1'>Created {new Date(created_at).toLocaleDateString()}</Text>
            <Text category='p1'>Last Updated {new Date(updated_at).toLocaleDateString()}</Text>

            <Layout style={{ flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap', paddingTop: 12 }}>
                {(!isPoallCampaign) ? (
                    <>
                        <Button
                            onPress={() => navigation.navigate('CreateSurvey', { parentCampaignId: id, parentCampaignTitle: title })}
                            style={{ marginLeft: 0, marginRight: 20 }}
                            // appearance='outline' 
                            status='basic'
                            icon={(style) => <Icon {...style} name='plus-circle-outline' />}
                        >
                            {`Add Survey`}
                        </Button>
                        {(user.product_plan.title === 'Premium' || user.product_plan.title === 'Platinum') ? (
                            <>
                                {Platform.OS === 'web' ?
                                    <Button
                                        onPress={() => navigation.navigate('EditCampaign', { campaign: params.campaign })}
                                        // appearance='outline'
                                        status='basic'
                                        icon={(style) => <Icon {...style} name='edit-outline' />}
                                    >
                                        {Platform.OS === 'web' ? 'Edit' : undefined}
                                    </Button>
                                    : undefined
                                }
                            </>
                        ) : (
                            <Text appearance='hint'>{``}</Text>
                        )}
       
                    </>
                ) : (
                    <Text appearance='hint'>{``}</Text>
                )}
            </Layout>
        </Card>
    );
    const renderFooter = (): React.ReactElement => (
        <Card style={{ marginBottom: pageSpacerHorizontal }}>
            <Text category='p1'>{'\n'}</Text>
        </Card>
    );
   

    {Platform.OS !== 'web' && navigation.setOptions({
        headerRight: () => (
            <Button
                onPress={() => navigation.navigate('EditCampaign', { campaign: params.campaign })}
                appearance='ghost'
                status='basic'
                icon={(style) => <Icon {...style} name='edit-outline' />}
                style={{ marginLeft: 0, marginRight: 10 }}
            >
                {Platform.OS === 'web' ? 'Edit' : undefined}
            </Button>
        )
    })};

    return (
        <Layout level='3' style={{ flex: 1 }}>
            <FlatList
                data={surveys}
                renderItem={renderSurvey}
                style={{ flex: 1, paddingLeft: pageSpacerHorizontal, paddingRight: pageSpacerHorizontal }}
                // keyExtractor={keyExtractor}
                ListHeaderComponent={renderHeader}
                ListFooterComponent={renderFooter}
            />
        </Layout>
    );
    
}


const styles = StyleSheet.create({
    container: {
        paddingTop: 50,
        paddingLeft: 50,
        paddingRight: 50
    }
});
